import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityDeleteStateProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityDeleteState = async (id: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${id}/delete-stats`);

const useGetCommunityDeleteState = ({
  id,
  queryParams,
}: UseGetCommunityDeleteStateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-delete-state", id],
    queryFn: () => getCommunityDeleteState(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetCommunityDeleteState;
